import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAppSelector } from '../hooks/index';

const navLinks = [
  { to: '/features', label: 'Features' },
  { to: '/pricing', label: 'Pricing' },
  { to: '/demo', label: 'Demo' },
  { to: '/about', label: 'About' },
  { to: '/blog', label: 'Blog' },
  { to: '/contact', label: 'Contact' },
];

const TopBar: React.FC = () => {
  const location = useLocation();
  const { token, role } = useAppSelector((state) => state.auth);
  const isAuthenticated = !!token;

  return (
    <nav className="w-full bg-white shadow-sm">
      <div className="max-w-4xl mx-auto flex justify-between items-center py-3 px-4">
        <div className="flex items-center space-x-8">
          <Link
            to="/"
            className="text-xl font-bold text-primary-600 font-playfair tracking-tight"
          >
            Content Repurposer
          </Link>
          <div className="hidden md:flex space-x-5">
            {navLinks.map(link => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-gray-700 hover:text-primary-600 font-poppins font-medium transition-colors${location.pathname === link.to ? ' underline' : ''}`}
              >
                {link.label}
              </Link>
            ))}
            {isAuthenticated && (
              <Link
                to="/dashboard"
                className={`text-gray-700 hover:text-primary-600 font-poppins font-medium transition-colors${location.pathname === '/dashboard' ? ' underline' : ''}`}
              >
                Dashboard
              </Link>
            )}
            {(role === 'admin' || role === 'superadmin') && (
              <Link
                to="#"
                className={`text-gray-700 hover:text-primary-600 font-poppins font-medium transition-colors`}
                onClick={e => { e.preventDefault(); alert('Manage Users: UI not implemented'); }}
              >
                Manage Users
              </Link>
            )}
            {role === 'superadmin' && (
              <Link
                to="#"
                className={`text-gray-700 hover:text-primary-600 font-poppins font-medium transition-colors`}
                onClick={e => { e.preventDefault(); alert('Role Management: UI not implemented'); }}
              >
                Role Management
              </Link>
            )}
          </div>
        </div>
        <div className="flex items-center space-x-3">
          {!isAuthenticated && (
            <>
              <Link
                to="/login"
                className="text-gray-700 hover:text-primary-600 font-poppins font-medium transition-colors"
              >
                Login
              </Link>
              <Link
                to="/signup"
                className="text-white bg-primary-600 hover:bg-primary-700 font-poppins font-medium px-4 py-2 rounded-lg shadow transition-colors"
              >
                Sign Up
              </Link>
            </>
          )}
          {isAuthenticated && (
            <span className="text-primary-600 font-poppins font-medium px-4 py-2 rounded-lg bg-primary-100">
              {role}
            </span>
          )}
        </div>
      </div>
    </nav>
  );
};

export default TopBar;
